// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Summary, { SummaryRow, SummaryRule } from '../../../../../elements/Summary/Summary';
import { getPaymentInfo } from '../../../../new-order/CheckoutStep/utils';

import style from './PurchaseSummary.scss';

import type { Node } from 'react';
import type { Order, OrderInvoice } from '../../../../../entities';
import type { LocalValuesState } from '../../../../local-values/duck';

type Props = {
  localValues: LocalValuesState;
  order: Order;
  contentBottom?: Node;
};

export const PurchaseSummaryLoading = ({ orderId }: { orderId: string }) => (
  <Summary titleIntl="summary.title.detail"
           subtitleExtra={orderId}
           disabled/>
);

export default class PurchaseSummary extends Component<Props> {
  render() {
    const { order, contentBottom  } = this.props;
    const isClassic = !!order && !!order.serviceTier;
    const invoice: OrderInvoice = (order: Order).invoice;
    const paymentProcessorImage = getPaymentInfo(invoice);
    return (
      <Summary titleIntl="summary.title.detail"
               subtitleExtra={order.id}>
        {!!invoice.payment.paymentData &&
        <div className={style.paymentMethodWrap}>
          <FormattedMessage id="summary.detail.paymentMethod">{
            txt => <p className={style.title}>{txt}:</p>
          }</FormattedMessage>
          <div className={style.dataWrap}>
            <img className={style.paymentMethod}
                 src={paymentProcessorImage}/>
            <span className={style.lastDigits}>{invoice.payment.paymentData.lastDigits}</span>
          </div>
        </div>}
        {!!isClassic &&
        <Fragment>
          <SummaryRow labelIntl="summary.detail.itemTotal"
                      content={`$ ${invoice.detail.itemTotal}`}/>
          <SummaryRow labelIntl="summary.detail.taxes"
                      hintIntl="summary.detail.taxes.tooltip"
                      content={`$ ${invoice.detail.taxes}`}/>
          <SummaryRow labelIntl="summary.detail.shipping"
                      hintIntl="summary.detail.shipping.tooltip"
                      content={`$ ${invoice.detail.shipping}`}/>
          <SummaryRule/>
        </Fragment>}
        {!!isClassic &&
        <SummaryRow labelIntl="summary.detail.subtotal"
                    noTopPadding
                    content={`$ ${invoice.detail.subtotal}`}/>}
        <SummaryRow labelIntl="summary.detail.importationFee"
                    hintIntl="summary.detail.importationFee.tooltip"
                    content={`$ ${invoice.detail.importationFee}`}/>
        {!!invoice.detail.customsDuties &&
        <SummaryRow labelIntl="summary.detail.customsDuties"
                    content={`$ ${invoice.detail.customsDuties}`}/>}
        <SummaryRow labelIntl="summary.detail.qempo"
                    content={`$ ${invoice.detail.qempo}`}/>
        <SummaryRow labelIntl="summary.detail.national"
                    hintIntl="summary.detail.national.tooltip"
                    content={`$ ${invoice.detail.lastMileShipping}`}/>
        <FormattedMessage id="summary.detail.warranty.free">{
          txt => <SummaryRow labelIntl="summary.detail.warranty"
                             color="green"
                             content={txt}/>
        }</FormattedMessage>
        {!!(order: Order).couponCode && !!invoice.detail.couponDeduction &&
        <SummaryRow labelIntl="summary.detail.coupon"
                    labelNoColon
                    labelExtra={`${(order: Order).couponCode} :`}
                    color="lightBlue"
                    content={`$ ${invoice.detail.coupon}`}/>}
        <SummaryRule/>
        <SummaryRow labelIntl="summary.detail.total"
                    color="black"
                    bold
                    noTopPadding
                    content={`$ ${invoice.detail.total}`}/>
        {contentBottom}
      </Summary>

    );
  }

  /*render() {
    const { openShipping } = this.state;
    const { localValues, order } = this.props;
    const countryIntl = order &&
      getLocalizedCountry(order.deliveryCountry.code, this.context.intl.formatMessage, localValues.countriesMap);
    const weight: string = order && order.items
      .reduce((acum: number, item: Item) => acum + parseFloat(item.weight) * item.amount, 0)
      .toFixed(2);
    const refund: ?number = order && order.invoice && order.invoice.detail &&
      (parseFloat(order.invoice.detail.couponDeduction) + parseFloat(order.invoice.detail.itemTotalDeduction) +
        parseFloat(order.invoice.detail.lastMileShippingDeduction) + parseFloat(order.invoice.detail.servicesDeduction) +
        parseFloat(order.invoice.detail.shippingDeduction) + /!*parseFloat(order.invoice.detail.subtotalDeduction) +*!/
        + parseFloat(order.invoice.detail.taxesDeduction) + parseFloat(order.invoice.detail.warrantyDeduction));
    const itemsByStores: ?ItemsByStore[] = order && groupItems(order.items);
    return (
      <section className={style.summaryWrap}>
        <FormattedMessage id="order.summary.title.orderDetail">{
          txt => <h3 className={style.title}>{txt} {order && order.id}</h3>
        }</FormattedMessage>
        <section className={classNames(formStyle.formWrap, style.formWrap)}>
          <section className={classNames(formStyle.row, formStyle.dualWrap)}>
            <article className={formStyle.col}>
              <FormattedMessage id="order.summary.purchaseDate">{
                txt => (<label className={formStyle.label}>{txt}</label>)
              }</FormattedMessage>
              {order && order.invoice && order.invoice.payment &&
              <p className={style.dates}>{moment(order.invoice.payment.updatedAt).utc().format('MMMM DD, YYYY', { trim: false })}</p>}
            </article>
            <article className={formStyle.col}>
              <FormattedMessage id="order.summary.estimatedDate">{
                txt => (<label className={formStyle.label}>{txt}</label>)
              }</FormattedMessage>
              <p className={style.dates}>{order && moment(order.beforeDate).utc().format('MMMM DD, YYYY', { trim: false })}</p>
            </article>
          </section>
          {order && order.shippingAddress && <section className={classNames(formStyle.row)}>
            <FormattedMessage id="order.summary.shippingAddress">{
              txt => (<label className={formStyle.label}>{txt}</label>)
            }</FormattedMessage>
            <p>{order.shippingAddress.firstName} {order.shippingAddress.lastName}</p>
            <p>{order.shippingAddress.idNumber}</p>
            <p>{getFullAddress(order.shippingAddress)}</p>
            <p>{getFullAdmin(order.shippingAddress)}, {countryIntl}</p>
          </section>}

        </section>
        {/!*<article className={style.wrap}>
          <FormattedMessage id="order.summary.weight">{
            txt => <span>{txt}:</span>
          }</FormattedMessage>
          <span>{weight} Kg</span>
        </article>*!/}

        <section className={classNames(formStyle.formWrap, style.formWrap)}>
          <section className={classNames(formStyle.row, formStyle.dualWrap)}>
            <article className={formStyle.col}>
              <FormattedMessage id="order.summary.paymentMethod">{
                txt => (<label className={formStyle.label}>{txt}</label>)
              }</FormattedMessage>
              {order && <img className={style.paymentMethod}
                             src={getPaymentInfo(order.invoice)}/>}
            </article>
            <article className={formStyle.col}>
              {order && order.invoice && order.invoice.payment && order.invoice.payment.paymentData &&
              order.invoice.payment.paymentData.lastDigits &&
              <p className={style.lastDigits}>{order.invoice.payment.paymentData.lastDigits}</p>}
            </article>
          </section>
        </section>

        <FormattedMessage id="order.summary.title.paymentSummary">{
          txt => <h3 className={style.title}>{txt}</h3>
        }</FormattedMessage>

        <article className={style.wrap}>
          <FormattedMessage id="order.summary.itemTotal">{
            txt => <span>{txt}:</span>
          }</FormattedMessage>
          <span>{`$ ${order && order.invoice.detail.itemTotal}`}</span>
        </article>
        <article className={style.wrap}>
          <FormattedMessage id="order.summary.taxes">{
            txt => <span>{txt}: <Tooltip id="taxes" intl="order.summary.taxes.tooltip"/></span>
          }</FormattedMessage>
          <span>{`$ ${order && order.invoice.detail.taxes}`}</span>
        </article>

        {/!*<article className={classNames(style.shipping, style.wrap, { [style.open]: openShipping })}
                 onClick={_ => this.setState((state: State) => ({ openShipping: !state.openShipping }))}>
          <FormattedMessage id="order.summary.shipping">{
            txt => <span><i className={classNames(
              { [icons.iconChevronUpMedium]: openShipping },
              { [icons.iconChevronDownMedium]: !openShipping })}/> {txt}</span>
          }</FormattedMessage>
          <span>{`$ ${order.invoice.detail.shipping}`}</span>
        </article>
        {openShipping && <section className={style.shippingContent}>
          {itemsByStores && itemsByStores.map((x: ItemsByStore, i: number) => {
            const s = x.items.reduce((acum: number, i: Item) => acum + parseFloat(i.shipping), 0).toFixed(2);
            const a = x.items.reduce((acum: number, i: Item) => acum + i.amount, 0);
            return <article key={i}
                            className={style.wrap}>
              <span className={style.shippingContentText}>({a}) {x.name}</span>
              <span className={style.shippingContentText}>$ {s}</span>
            </article>;
          })}
        </section>}*!/}
        <article className={style.wrap}>
          <FormattedMessage id="order.summary.title.shipping">{
            txt => <h3 className={classNames(style.title, style.shippingTitle)}>{txt}:
              <Tooltip id="shipping" intl="order.summary.shipping.tooltip"/></h3>
          }</FormattedMessage>
          <span>{`$ ${order.invoice.detail.shipping}`}</span>
        </article>
        <section className={style.shippingContent}>
          {itemsByStores && itemsByStores.map((x: ItemsByStore, i: number) => {
            const s = x.items.reduce((acum: number, i: Item) => acum + parseFloat(i.shipping), 0).toFixed(2);
            const a = x.items.reduce((acum: number, i: Item) => acum + i.amount, 0);
            return <article key={i}
                            className={style.wrap}>
              <span className={style.shippingContentText}>({a}) {x.name}</span>
              <span className={style.shippingContentText}>$ {s}</span>
            </article>;
          })}
        </section>
        <article className={style.wrap}>
          <FormattedMessage id="order.summary.totalUSA">{
            txt => <span>{txt}:</span>
          }</FormattedMessage>
          <span>{`$ ${order && order.invoice.detail.subtotal}`}</span>
        </article>
        <article className={style.wrap}>
          <FormattedMessage id="order.summary.importation">{
            txt => <span>{txt}: <Tooltip id="taxes" intl="order.summary.importation.tooltip"/></span>
          }</FormattedMessage>
          <span>{`$ ${order && order.invoice.detail.services}`}</span>
        </article>
        <article className={style.wrap}>
          <FormattedMessage id="order.summary.national">{
            txt => <span>{txt}: <Tooltip id="taxes" intl="order.summary.national.tooltip"/></span>
          }</FormattedMessage>
          <span>{`$ ${order && order.invoice.detail.lastMileShipping}`}</span>
        </article>
        {order && order.couponCode && <article className={style.wrap}>
          <FormattedMessage id="order.summary.coupon">{
            txt => <span className={style.coupon}>{txt} {order.couponCode}:</span>
          }</FormattedMessage>
          <span className={style.coupon}>{`$ ${order.invoice.detail.coupon}`}</span>
        </article>}
        {typeof refund === 'number' && !isNaN(refund) && refund !== 0 && <article className={style.wrap}>
          <FormattedMessage id={order && order.invoice.hasPaidRefunds ?
            'order.summary.refunded' : 'order.summary.pendingRefund'}>{
            txt => <span className={style.refund}>{txt}</span>
          }</FormattedMessage>
          <span className={style.refund}>{`$ ${refund.toFixed(2)}`}</span>
        </article>}
        <article className={style.wrap}>
          <FormattedMessage id="order.summary.title.total">{
            txt => <span className={classNames(style.title, style.lightBlue)}>{txt}:</span>
          }</FormattedMessage>
          <span className={style.lightBlue}>{`$ ${order && order.invoice.detail.total}`}</span>
        </article>

      </section>
    );
  }*/
}

PurchaseSummary.propTypes = {
  localValues: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  contentBottom: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/components/PurchaseSummary/PurchaseSummary.jsx